module.exports = __webpack_public_path__ + "img/bgApps.1bdc0117.png";